<div class="group-name-wrapper">
    <ng-container *ngIf="showToggleAllButton">
        <button class="show-toggle-button" (click)="toggleLayerGroupClicked($event)">
            <ng-container *ngIf="!listOpen">
                <img
                    class="chevron-icon"
                    src="../../../../assets/icons/chevron-right.svg"
                    alt="chevron up"
                    style="width: 0.4rem"
                />
            </ng-container>
            <ng-container *ngIf="listOpen">
                <img
                    class="chevron-icon"
                    src="../../../../assets/icons/chevron-down.svg"
                    alt="chevron down"
                    style="width: 0.6rem"
            /></ng-container>
        </button>
    </ng-container>
    <div class="group-name-row" (click)="selectLayerGroupClicked(groupElement.id)">
        <div #groupElement [attr.id]="'layer-list-group-' + groupInfo.id">
            {{ groupInfo.name }}
        </div>
        <div class="show-layers-buttons">
            <!-- <cds-button-inline
            (click)="
                !!(groupInfo.id !== undefined && showShowAllButton) && showAllLayersClicked($event)
            "
            [ngClass]="{
                active: groupInfo.id !== undefined && showShowAllButton,
                inactive: !(groupInfo.id !== undefined && showShowAllButton)
            }"
            ><cds-icon shape="eye"></cds-icon
        ></cds-button-inline> -->
            <!-- <cds-button-inline
            (click)="hideAllLayersClicked($event)"
            [ngClass]="{
                active: groupInfo.id !== undefined && showHideAllButton,
                inactive: !(groupInfo.id !== undefined && showHideAllButton)
            }"
            ><cds-icon shape="eye-hide"></cds-icon
        ></cds-button-inline> -->
            <ng-container *ngIf="groupInfo.id !== undefined && showManageLayersButton">
                <cds-button-inline
                    (click)="manageLayersClicked($event)"
                    [disabled]="manageLayersDisabled"
                    title="Choose layers to load"
                >
                    <cds-icon shape="plus"></cds-icon>
                </cds-button-inline>
            </ng-container>
            <ng-container *ngIf="groupInfo.id !== undefined && showHideAllButton">
                <cds-button-inline (click)="hideAllLayersClicked($event)"
                    ><cds-icon shape="eye-hide" [solid]="true"></cds-icon
                ></cds-button-inline>
            </ng-container>
        </div>
    </div>
</div>
